export default function UserAvatar(props){
	const user = props.user || {}
	return user.login || ''
	//<button></button>

}
